import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
import { SmartComponent } from "smart-component-js";

class HaiVintoCtrl extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.init();
  }
  init() {
    this.loadChildComponents(this);
    let pt = this.getUrlParameter("pt");
    const play_mode = this.getUrlParameter("pm");

    if (pt) {
      $("#premio-visual").fadeIn(300);
      let pm = this.getUrlParameter("pm");
      $("#richiedi-premio").attr(
        "href",
        "/promozioni/dona-felicita-a-colazione-finiper/completa-dati?pt=" +
          pt +
          "&pm=" +
          pm
      );
    } else {
      //TODO Gestire errore no parametri
    }

    $("h2.playmode_1").toggle(
      !play_mode.length || (play_mode && play_mode == "1")
    );
    $("h2.playmode_3").toggle(play_mode && play_mode == "3");
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
}

export default HaiVintoCtrl;
